import { ThemeDefinition, VuetifyOptions } from 'vuetify';

const blackColor = '#212121';
const brandRedColor = '#E40613';
const primaryVioletColor = '#073855';
const whiteColor = '#FFFFFF';
const grey700Color = '#4A4A4A';
const grey500Color = '#979797';
const grey300Color = '#BFBFBF';
const grey200Color = '#D4D4D4';
const localLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    // vuetify colors
    error: '#D50000',
    info: '#2196F3',
    primary: primaryVioletColor,
    secondary: whiteColor,
    success: '#388E3C',
    warning: '#FB6B18',
    background: grey200Color,
    'on-surface': blackColor,
    'on-background': blackColor,

    // custom colors
    contrast: blackColor,
    systemPrimary: brandRedColor,
    systemToolbar: brandRedColor,
    navigationDrawer: brandRedColor,
    neutral: grey500Color,
    'neutral-light': whiteColor,
    'neutral-border': grey300Color,
    'on-navigationDrawer': grey700Color,
    'on-systemToolbar': whiteColor,
  },
  variables: {
    'button-prepend-svg-margin': '-4px',
  },
};

export const localTheme: VuetifyOptions['theme'] = {
  defaultTheme: 'light',
  themes: {
    light: localLightTheme,
  },
};
